import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDefectDojoIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 10.1273H12.808H45.8706V45.5727H10.1273V25.616H0V55.7H55.9978V0H0V10.1273Z",
		fill: "#5445FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M34.8521 19.9648H19.3633V35.4536H34.8521V19.9648Z",
		fill: "#32C4EC"
	})]
});
export default SvgDefectDojoIcon;
